const types = {
   SET_USER_DATA: 'SET_USER_DATA',
   LOGIN: 'LOGIN',
   REGISTER: 'REGISTER',
   LOGOUT: 'LOGOUT',
   CHANGE_AVATAR: 'CHANGE_AVATAR',

   USER_CHANGE_PARAMETER: 'USER_CHANGE_PARAMETER',
   USER_CHANGE_MODE: 'USER_CHANGE_MODE',
   USER_RESET_MODE_CHANGED: 'USER_RESET_MODE_CHANGED',
}

export default types
